class HelperUtils {
  static timeOfDayToString(timeOfDay) {
    const paddedHours = timeOfDay.hours.toString().padStart(2, '0');
    const paddedMinutes = timeOfDay.minutes.toString().padStart(2, '0');
    return `${paddedHours}:${paddedMinutes}`;
  }
}

module.exports = HelperUtils;
